import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_ChildAndAdolescentMentalHealthRehabilitationTreatmentRequestForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_ChildAndAdolescentMentalHealthRehabilitationTreatmentRequestForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                <center><h3> Child and Adolescent Mental Health Rehabilitation Treatment Request Form </h3></center>

                </p> 

                <p className='w-750'>
                    Please complete this form in its entirety — incomplete forms will delay processing.
                    Please return to AmeriHealth Caritas Louisiana BH UM at <b>1-855-301-5356.</b>
                    For assistance, contact <b>1-855-285-7466.</b>
                </p>

                <p className='w-750'><h3>Provider information</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider name:</span>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group/agency name:</span>
                            <input type='text' id='txtAgencyName' name='txtAgencyName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInNetwork' name='cbInNetwork' className='add-only' value='InNetwork' /> In-network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOutOfNetwork' name='cbOutOfNetwork' className='add-only' value='OutNetwork' /> Out of network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCredentialingProcess' name='cbCredentialingProcess' className='add-only' value='InCredentialingProcess' /> In credentialing process
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Provider credential: &nbsp;</b>
                            <input type='checkbox' id='cbProviderCredential_1' name='cbProviderCredential_1' className='add-only' value='Md' /> M.D. &nbsp;
                            <input type='checkbox' id='cbProviderCredential_2' name='cbProviderCredential_2' className='add-only' value='Phd' /> Ph.D. &nbsp;
                            <input type='checkbox' id='cbProviderCredential_3' name='cbProviderCredential_3' className='add-only' value='Lmhp' /> LMHP &nbsp;
                            <input type='checkbox' id='cbProviderCredential_4' name='cbProviderCredential_4' className='add-only' value='Lac' /> LAC &nbsp;
                            <input type='checkbox' id='cbProviderCredential_5' name='cbProviderCredential_5' className='add-only' value='Np' /> N.P.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProviderCredential_6' name='cbProviderCredential_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtProviderCredential_6' name='txtProviderCredential_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical address:</span>
                            <input type='text' id='txtPhysicalAddress' name='txtPhysicalAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax:</span>
                            <input type='text' id='txtFax' name='txtFax' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid/provider/NPI #:</span>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact name:</span>
                            <input type='text' id='txtContactName' name='txtContactName' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>DSM diagnosis</h3></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Dx:</span>
                            <input type='text' id='txtPrimary' name='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Secondary Dx:</span>
                            <input type='text' id='txtSecondary' name='txtSecondary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medical Dx:</span>
                            <input type='text' id='txtMedical' name='txtMedical' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            If the member has a substance use and/or HIV diagnosis, has consent to release information for these related conditions been obtained?<br />
                            <input type='radio' id='rbHivDiagnosisY' name='rbHivDiagnosis' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHivDiagnosisN' name='rbHivDiagnosis' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHivDiagnosisNa' name='rbHivDiagnosis' className='add-only' value='Na' /> N/A
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>PCP information and collaboration</span></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Has information been shared with the primary care provider (PCP) or other providers regarding:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The initial evaluation and treatment plan?</span>
                            <input type='radio' id='rbInitialEvaluationY' name='rbInitialEvaluation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInitialEvaluationN' name='rbInitialEvaluation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The updated evaluation and treatment plan?</span>
                            <input type='radio' id='rbUpdatedEvaluationY' name='rbUpdatedEvaluation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbUpdatedEvaluationN' name='rbUpdatedEvaluation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Other behavioral health providers' names and date last notified; PCP name and date last notified:
                            <input type='text' id='txtBehavioralHealthProviders' name='txtBehavioralHealthProviders' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    If no, please explain:
                    <textarea id='txtExplain' name='txtExplain' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Symptoms</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_1' name='cbSuicidal_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_2' name='cbSuicidal_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_3' name='cbSuicidal_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_4' name='cbSuicidal_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_5' name='cbSuicidal_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicidal</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_1' name='cbHomicidal_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_2' name='cbHomicidal_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_3' name='cbHomicidal_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_4' name='cbHomicidal_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_5' name='cbHomicidal_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assault/Violent</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAssault_1' name='cbAssault_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_2' name='cbAssault_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_3' name='cbAssault_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_4' name='cbAssault_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_5' name='cbAssault_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is member prescribed medications?</span>
                            <input type='radio' id='rbPrescribedMedicationsY' name='rbPrescribedMedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPrescribedMedicationsN' name='rbPrescribedMedications' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Prescribing physicians' names:</span>
                            <input type='text' id='txtPrescribingPhysicians' name='txtPrescribingPhysicians' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Is the member compliant with medications? </b>
                            <input type='radio' id='rbMemberCompliantWithMedicationsY' name='rbMemberCompliantWithMedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMemberCompliantWithMedicationsN' name='rbMemberCompliantWithMedications' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please list medications and dosages:</span>
                            <input type='text' id='txtDosages' name='txtDosages' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Please attach the following to the treatment request: &nbsp;</b>
                            <input type='checkbox' id='cbClinicalAssessment' name='cbClinicalAssessment' className='add-only' value='ClinicalAssessment' /> Clinical assessment &nbsp;
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='Treatment plan' /> Treatment plan
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Treatment request: please check services being requested</span></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCommunityPsychiatric' name='cbCommunityPsychiatric' className='add-only' value='CommunityPsychiatricSupport' /> <b>Community psychiatric support and treatment (CPST):</b>
                            Goal-directed and solution-focused community-based interventions.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_1' name='txtServiceCodeBeingRequested_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_1' name='txtNumberOfUnits_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticGroupHome' name='cbTherapeuticGroupHome' className='add-only' value='TherapeuticGroup' /> <b>Therapeutic group home (TGH):</b>
                            Community-based residential services in a home-like setting.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_2' name='txtServiceCodeBeingRequested_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_2' name='txtNumberOfUnits_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHomeBuilders' name='cbHomeBuilders' className='add-only' value='HomeBuilders' /> <b>Home builders (HB): </b>
                            Provides youth between birth and 18 years old intensive in-home cognitive behavioral therapy through family
                            therapy and parent training. Youth are at risk of out-of-home placement, returning from out-of-home placement, or have serious
                            behavior problems at home and school.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_3' name='txtServiceCodeBeingRequested_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_3' name='txtNumberOfUnits_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMultiSystemicTherapy' name='cbMultiSystemicTherapy' className='add-only' value='MultiSystemicTherapy' /> <b>Multi-systemic therapy (MST): </b>
                            Provides youth between 12 and 17 years old intensive home-, family- and community-based therapy.
                            Youth are at risk of out-of-home placement or are returning from out-of-home placement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_4' name='txtServiceCodeBeingRequested_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_4' name='txtNumberOfUnits_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyFunctionalTherapy' name='cbFamilyFunctionalTherapy' className='add-only' value='FamilyFunctionalTherapy' /> <b>Family functional therapy (FFT): </b>
                            For youth between 10 and 18 years old, targeting behaviors that impact family functioning.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_5' name='txtServiceCodeBeingRequested_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_5' name='txtNumberOfUnits_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychosocialRehabilitation' name='cbPsychosocialRehabilitation' className='add-only' value='PsychosocialRehabilitation' /> <b>Psychosocial rehabilitation (PSR)</b>
                            Services to restore a member to the fullest possible extent as an active and productive member of his or her family and community.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. PSR individual in the office, # of units per week:</span>
                            <input type='text' id='txtPsrIndividualOffice' name='txtPsrIndividualOffice' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>2. PSR individual in the community, # of units per week:</span>
                            <input type='text' id='txtPsrIndividualCommunity' name='txtPsrIndividualCommunity' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3. PSR group in the office, # of units per week: </span>
                            <input type='text' id='txtPsrGroupOffice' name='txtPsrGroupOffice' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>4. PSR group in the community, # of units per week: </span>
                            <input type='text' id='txtPsrGroupCommunity' name='txtPsrGroupCommunity' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCrisisStabilization' name='cbCrisisStabilization' className='add-only' value='CrisisStabilizatio' /> <b>Crisis stabilization:</b>
                            Short-term and intensive supportive resources for youth and family; out-of-home option to avoid psychiatric
                            inpatient or institutional treatment. This service is being requested to prevent the member from inpatient or institutional treatment,
                            and the member is currently in crisis. Up to seven days will be authorized initially, and a child cannot receive more than 30 calendar
                            days of this service per year.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_6' name='txtServiceCodeBeingRequested_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_6' name='txtNumberOfUnits_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>For all initial requests, please indicate the below</span></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. The member has been unmanageable safely at a less intensive level of care within the last week. </span>
                            <input type='radio' id='rbLessIntensiveLevelY' name='rbLessIntensiveLevel' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLessIntensiveLevelN' name='rbLessIntensiveLevel' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. The member is currently in short-term respite or any other mental health or substance use disorder services.</span>
                            <input type='radio' id='rbMentalHealthOrSubstanceUseY' name='rbMentalHealthOrSubstanceUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealthOrSubstanceUseN' name='rbMentalHealthOrSubstanceUse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtPleaseExplain' name='txtPleaseExplain' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. The member has displayed any of the following within the last week (check all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFireSetting' name='cbFireSetting' className='add-only' value='FireSetting' /> Fire setting
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnmanageableAggression' name='cbUnmanageableAggression' className='add-only' value='AngryOutbursts' /> Angry outbursts/unmanageable aggression
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfInjuriousBehaviors' name='cbSelfInjuriousBehaviors' className='add-only' value='SelfInjuriousBehaviors' /> Self-injurious behaviors
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='DelusionsHallucinationsDisorganizedBehavior' /> Delusions/hallucinations/disorganized thoughts, speech or behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRunningAway' name='cbRunningAway' className='add-only' value='RunningAwayForMoreThanDay' /> Running away for more than 24 hours
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbArrest' name='cbArrest' className='add-only' value='ArrestConfirmedIllegalActivity' /> Arrest/confirmed illegal activity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDaredevilOrImpulsiveBehaviors' name='cbDaredevilOrImpulsiveBehaviors' className='add-only' value='DaredevilImpulsiveBehaviors' /> Daredevil or impulsive behaviors
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPersistentViolation' name='cbPersistentViolation' className='add-only' value='PersistentViolationCourtOrders' /> Persistent violation of court orders
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexuallyInappropriate' name='cbSexuallyInappropriate' className='add-only' value='SexuallyInappropriateAggressiveAbusive' /> Sexually inappropriate/aggressive/abusive
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEncopresis' name='cbEncopresis' className='add-only' value='EncopresisAndFecesSmearing' /> Encopresis and feces smearing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. The behaviors have persisted for at least six months</span>
                            <input type='radio' id='rbPersistedY' name='rbPersisted' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPersistedN' name='rbPersisted' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5. The behaviors are expected to continue longer than one year without treatment. </span>
                            <input type='radio' id='rbWithoutTreatmentY' name='rbWithoutTreatment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWithoutTreatmentN' name='rbWithoutTreatment' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. The member has had unsuccessful treatment in any of the following within the last 6-12 months (check all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOutpatientTherapyServices' name='cbOutpatientTherapyServices' className='add-only' value='OutpatientTherapyServices' /> Outpatient therapy services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCpst' name='cbCpst' className='add-only' value='Cpst' /> CPST
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth' name='cbMentalHealth' className='add-only' value='MentalHealthRehabilitationServices' /> Mental health rehabilitation services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricInpatient' name='cbPsychiatricInpatient' className='add-only' value='ThreePsychiatricInpatientAdmissions' /> Three psychiatric inpatient admissions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentFosterCare' name='cbTreatmentFosterCare' className='add-only' value='TreatmentFosterCare' /> Treatment foster care
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalizationAdmissions' name='cbHospitalizationAdmissions' className='add-only' value='ThreePsychiatricPartialHospitalizationAdmissions' /> Three psychiatric partial hospitalization admissions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbResidentialTreatment' name='cbResidentialTreatment' className='add-only' value='ResidentialTreatmentTherapeuticGroupHome' /> Residential treatment and/or therapeutic group home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychiatricAdmissions' name='cbPsychiatricAdmissions' className='add-only' value='FourPsychiatricAdmissionsInpatient' /> Four psychiatric admissions to inpatient,
                            partial hospitalization program (PHP) or intensive outpatient program (IOP) in any combination
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. The member's support system has been any of the following within the last 6-12 months (check all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlanning' name='cbTreatmentPlanning' className='add-only' value='InvolvedTreatmentTreatmentPlanning' /> Involved in treatment and treatment planning
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAbusive' name='cbAbusive' className='add-only' value='Abusive' /> Abusive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnavailable' name='cbUnavailable' className='add-only' value='Unavailable' /> Unavailable
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntentionallySabotagingTreatments ' name='cbIntentionallySabotagingTreatments' className='add-only' value='IntentionallySabotagingTreatments' /> Intentionally sabotaging treatments
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnableToEnsureSafety' name='cbUnableToEnsureSafety' className='add-only' value='UnableEnsureSafety' /> Unable to ensure safety
                        </td>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHighRiskEnvironment' name='cbHighRiskEnvironment' className='add-only' value='HighRiskEnvironment' /> High-risk environment
                        </td>
                        
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbStructuredProgram' name='cbStructuredProgram' className='add-only' value='UnableManageIntensityMemberSymptomsWithoutStructuredProgram' /> Unable to manage the intensity of the member's symptoms without a structured program
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. The member's living environment (please check one):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSafeEnvironment' name='cbSafeEnvironment' className='add-only' value='MemberLivingEnvironment' /> Member is living in a safe environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLivingSkills' name='cbLivingSkills' className='add-only' value='MemberEmancipatedFamily' /> Member is emancipated from family and lacks independent living skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyEnvironment' name='cbFamilyEnvironment' className='add-only' value='MemberDemonstratedIntoleranceFamilyEnvironment' /> Member has demonstrated intolerance for family environment or adult authority and needs out-of-home placement
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>For all initial requests, please indicate the below (continued)</span></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. The member has severe impairment in the below (check all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbActivities' name='cbActivities' className='add-only' value='ActivitiesDailyLiving' /> Activities of daily living (ADLs)
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyRelationships' name='cbFamilyRelationships' className='add-only' value='FamilyRelationships' /> Family relationships
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCommunityLiving' name='cbCommunityLiving' className='add-only' value='CommunityLiving' /> Community living
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolPerformance' name='cbSchoolPerformance' className='add-only' value='SchoolPerformance' /> School performance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSocialRelationships' name='cbSocialRelationships' className='add-only' value='SocialRelationships' /> Social relationships
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>For all continued stay requests, please indicate the below</span></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>1. Within the last month the member has experienced and/or displayed the following (check all that apply):</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDisruptiveBehaviors' name='cbDisruptiveBehaviors' className='add-only' value='DisruptiveBehaviors' /> Disruptive behaviors
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHypomanicSymptoms' name='cbHypomanicSymptoms' className='add-only' value='HypomanicSymptoms' /> Hypomanic symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbObsessionsCompulsions' name='cbObsessionsCompulsions' className='add-only' value='ObsessionsCompulsions' /> Obsessions/compulsions
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisis' name='cbCrisis' className='add-only' value='AnAfterHoursCrisis' /> An after-hours crisis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychosis' name='cbPsychosis' className='add-only' value='Psychosis' /> Psychosis
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbArrest1' name='cbArrest1' className='add-only' value='Arrest' /> Arrest
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSuicidalAndHomicidal' name='cbSuicidalAndHomicidal' className='add-only' value='SuicidalHomicidalIdeations' /> Suicidal and/or homicidal ideations without intent
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeglectingAdls' name='cbNeglectingAdls' className='add-only' value='NeglectingNeedsMonitoring' /> Neglecting ADLs and/or needs monitoring for ADLs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricMedication' name='cbPsychiatricMedication' className='add-only' value='PsychiatricMedicationNoncompliance' /> Psychiatric medication noncompliance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSchoolProblems' name='cbSchoolProblems' className='add-only' value='SchoolProblemsResultingSuspensionsExpulsion' /> School problems resulting in suspensions or expulsion
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPostTraumaticStress' name='cbPostTraumaticStress' className='add-only' value='PostTraumaticStressDisorder' /> Post-traumatic stress disorder (PTSD) or history of trauma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInappropriateSocialBehaviors' name='cbInappropriateSocialBehaviors' className='add-only' value='OngoingIsolationInappropriate' /> Ongoing isolation and/or inappropriate social behaviors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnxietyDepressedMood' name='cbAnxietyDepressedMood' className='add-only' value='AnxietyDepressedMoodWith' /> Anxiety and/or depressed mood with associated symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHostilityOrIntimidation' name='cbHostilityOrIntimidation' className='add-only' value='InterpersonalConflictsThat' /> Interpersonal conflicts that can include angry outbursts, physical altercations,
                            hostility or intimidation to support system, manipulation, and/or poor boundaries
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <b>2. The member is receiving the following services:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndicateProgramInformation' name='cbIndicateProgramInformation' className='add-only' value='SchoolVocational' /> School and/or vocational program; indicate program information: &nbsp;
                            <input type='text' id='txtIndicateProgramInformation' name='txtIndicateProgramInformation' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInterpersonalSkills' name='cbInterpersonalSkills' className='add-only' value='SelfManagementInterpersonal' /> Self-management or interpersonal skills training; indicate frequency: &nbsp;
                            <input type='text' id='txtInterpersonalSkills' name='txtInterpersonalSkills' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndicateFrequency' name='cbIndicateFrequency' className='add-only' value='BehaviorContractSymptomManagement' /> Behavior contract or symptom management plan; indicate frequency: &nbsp;
                            <input type='text' id='txtIndicateFrequency' name='txtIndicateFrequency' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychoeducation' name='cbPsychoeducation' className='add-only' value='PsychoeducationIndicateFrequency' /> Psychoeducation; indicate frequency: &nbsp;
                            <input type='text' id='txtPsychoeducation' name='txtPsychoeducation' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividualizedTreatmentPlan' name='cbIndividualizedTreatmentPlan' className='add-only' value='IndividualizedTreatmentPlan' /> Individualized treatment plan; indicate primary goals: &nbsp;
                            <input type='text' id='txtIndividualizedTreatmentPlan' name='txtIndividualizedTreatmentPlan' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyIndividualGroupTherapy' name='cbFamilyIndividualGroupTherapy' className='add-only' value='FamilyIndividualGroupTherapy' /> Family, individual, group therapy; indicate frequency: &nbsp;
                            <input type='text' id='txtFamilyIndividualGroupTherapy' name='txtFamilyIndividualGroupTherapy' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther' name='cbFamilyIndividualGroupTherapy' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>3. Additional clinical information to indicate member meets medical necessity for the requested services:</b>
                    <textarea id='txtAdditionalClinicalInformation' name='txtAdditionalClinicalInformation' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











